'use client'; 
import React,{useContext,useState,useEffect} from 'react'
import lp from '../images/producthome/lightning protection logo.svg'
import es from '../images/producthome/earth solution logo.svg';
import epit from '../images/producthome/epcc logo.svg';
import bfc from '../images/producthome/bfc logo.svg';
import prshield from '../images/producthome/product_shield.png';
import prshield2x from '../images/producthome/product_shield@2x.png';
import clp from '../images/producthome/clp_logo.svg';
import { ProductContext } from  './Productcontext';
import Image from 'next/image';
import { useRouter } from 'next/navigation';


const Producthomecontent = () => {
    const router = useRouter(); // Use Next.js router instead of react-router-dom
    const [leftPosition, setLeftPosition] = useState('10%');
    const { setCategory, selectedCategory } = useContext(ProductContext);
       // this for menu or fotter active item manage
    //    const [activeItem, setActiveItem] = useState(() => {
    //     if (typeof window !== 'undefined') {
    //       return localStorage.getItem('activeItem') || null;
    //     }
    //     return null;
    //   });
    
      // Update activeItem in localStorage whenever it changes
    //   useEffect(() => {
    //     if (activeItem) {
    //       localStorage.setItem('activeItem', activeItem);
    //     }
    //     console.log("use effect active item="+activeItem);
    //   }, [activeItem]);
      
    const divStyle = {
        backgroundImage: `url(/images/producthome/product_shield.png)`, // Reference from public folder
    };

    useEffect(() => {
        function handleResize() {
            const screenWidth = window.innerWidth;
            // Calculate the left position dynamically based on screen width
            const newLeftPosition = `${(screenWidth) / 100}px`; // Adjust the percentage value as needed
            setLeftPosition(newLeftPosition);
        }

        // Initial call to handleResize
        handleResize();

        // Add event listener for window resize
        window.addEventListener('resize', handleResize);

        // Clean up event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []); // Empty dependency array to ensure effect runs only once

    const handleItemClick = (item) => {
            //console.log("Current Path:", router.pathname); // Log the current path
            //console.log("Navigating to:", item); // This should log the correct item
            setCategory(item);
            localStorage.setItem('selectedCategory',item);
            // localStorage.setItem('activeItem', item);

        if(item=='ele'){
            // localStorage.setItem('activeItem', 'ele');
            router.push(`/ashlok-safe-earthing-electrodes`);
            

        }
        else if(item=='slpr'){
            // localStorage.setItem('activeItem', 'slpr');
            router.push(`/ashlok-lightning-protection-systems`);
            
        }
        else if(item=='clp')
            router.push(`/ashlok-conventional-lightning-protection`);
        else if(item=='epcc')
            router.push(`/ashlok-earthpit-chamber-cover`);
        else if(item=='bfc')
            router.push(`/ashlok-baron-backfill-compound`);
    };

    return (
        <div className=' w-full flex justify-center items-center mx-4 my-5'>
                <div className='flex flex-col  lg:space-x-14'>
            <div className='relative container max-w-screen-2xl flex flex-col lg:flex-row'>
                        
                    <div className='flex flex-col'>
                        <div className='relative flex  flex-col  lg:flex-row justify-start lg:justify-end lg:mx-5 '  onClick={() => handleItemClick('ele')}>
                            <div className="overflow-hidden cursor-pointer my-3 lg:my-0 w-full pr-[4.5em] md:pr-0 pl:0 md:pl-[3.2em] md:w-1/2  lg:w-full mx-0 md:mx-24 lg:mx-0  flex justify-center">
                                <Image width="100%" height="auto" src={es} alt="Earthing Solution Logo | Ashlok Safe Earthing Electrode Limited"/>
                            </div>
                            
                        </div>
                        <div className='lg:absolute   left:1/2 sm:top-1/4 lg:top-1/2 ' onClick={() => handleItemClick('epcc')}>
                            <div className="overflow-hidden cursor-pointer my-3 w-1/2  sm:w-full sm-small:mx-[6em]  mx-[2em]  md-small:mx-[12em] md:mx-0 md:w-full lg:mx-0 lg:my-0  pl:0 md:pl-[4.6em] lg:pl-[3em] lg:pr-[20em] flex justify-center">
                                <Image width="100%" height="auto" src={epit} alt="Earth Pit Chamber Cover Logo | Ashlok Safe Earthing Electrodes and Chamber Cover Manufacturer & Supplier"
                                                               />
                            </div>
                          
                        </div>

                    </div>
                    <div className="flex justify-center items-center overflow-hidden mr-6 lg:mr-0 lg:ml-2">
                            <Image width="100%"  height="auto" src={prshield} alt="Graphic representation of Ashlok's global product offerings. Highlighting key product categories including earthing solutions, lightning protection, backfill compounds, and earth pit chamber covers. The visual also showcases Ashlok's international reach with a map design embedded in the shield symbol" className="object-cover h-full" 
                            srcSet={`${prshield} 1x, ${prshield2x} 2x`}
                            priority
                            
                            />


                    </div>
                    <div className='flex flex-col'>       
                        <div className='realtive flex flex-row  justify-center pr-[0.9em] lg:pr-0  lg:mx-5'  onClick={() => handleItemClick('slpr')}>
                                    <div className="overflow-hidden cursor-pointer my-3 px-[0em]  md:px-[1.5em]  lg:my-0 md:w-1/3 lg:w-full ">
                                        <Image  width="100%"  height="auto" src={lp} alt="Lightning Protection Logo - Ashlok Safe Earthing Electrode Limited "/>
                                    </div>
                        </div>
                        {/* <div className='absolute top-1/2 items-start'  onClick={() => handleItemClick('bfc')}> */}
                        <div className='lg:absolute top-1/2 left-3/4 translate-x-22'  onClick={() => handleItemClick('bfc')}>
                                <div className="overflow-hidden cursor-pointer mb-3 lg:my-0 flex justify-center">
                                    <Image  width="100%" height="auto" src={bfc} alt="BackFill Compounds Logo - Ashlok BackFill Compounds providing eco-friendly earthing solutions across industries"/>
                                </div>
                        </div>
                    </div>

        </div>  
                <div className='flex  justify-center lg:justify-center items-center lg:mt-5 cursor-pointer' onClick={() => handleItemClick('clp')}>
                     <div className="overflow-hidden cursor-pointer flex justify-center sm:mx-[1em] md:mx-[1em] lg:mx-0">
                                <Image width="100%" height="auto" src={clp} alt="Conventional Lightning Protection System - Ashlok Safe Earthing Electrode Limited conventional lightning protection system for complete lightning safety"/>
                    </div>
                    </div>
        </div>
                {/* hide content */}
                <div>
                    <p className="sr-only">lightning protection</p>
                    <p className="sr-only">earth pit</p>
                    <p className="sr-only">earth pit chamber</p>
                    <p className="sr-only">back fill compound</p>
                </div>

        </div>
    )
}
export default Producthomecontent